import React, { useState, useEffect } from 'react';
import * as newsService from "../services/newsService";
import { Calendar } from 'primereact/calendar';
import SunEditor, { buttonList } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import Swal from 'sweetalert2';
import { FormatDateBG, StringToDateWithDash } from '../../utils/RegisterApplicationBodyFormatter';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export function AdminAllNewsList() {

    const [newsData, setNewsData] = useState([]);
    const [expandedItemId, setExpandedItemId] = useState(null);
    const [selNews, setSelectedNews] = useState({
        "title": "",
        "news": "",
        "data": null,
        "category_id": 0,
        "forHomePage": false
    });
    const [showModal, setShowModal] = useState(false);

    document.title = `Всички новини`;

    const handleContentChange = (e) => {
        const { name, value } = e.target;
        setSelectedNews({ ...selNews, [name]: value });
    };

    const handleContentChangeEditor = (e) => {

        setSelectedNews(prevSelNews => ({
            ...prevSelNews,
            news: e,
            // Preserve existing values for title and data
            title: prevSelNews.title,
            data: prevSelNews.data
        }));
    };

    useEffect(() => {
        const populateNews = async () => {
            try {
                newsService.getAll()
                    .then((res) => {
                        const sorted = res.sort((a, b) => {
                            const dateA = StringToDateWithDash(a.data);
                            const dateB = StringToDateWithDash(b.data);
                            return dateB - dateA; // за низходящ ред (новите първо)
                        });

                        setNewsData(sorted);
                    })
            } catch (error) {
                console.error('Error fetching data:', error.message);
            }
        };

        populateNews();
    }, []);


    const populateNews = async () => {
        try {
            newsService.getAll()
                .then((res) => {
                    setNewsData(res);
                })
        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };



    const handleExpand = (index) => {
        setExpandedItemId(index);

        let date = newsData[index].data.split('-');

        setSelectedNews(state => ({
            id_news: newsData[index].id_news,
            title: newsData[index].title,
            news: newsData[index].news,
            data: new Date(date[2], date[1] - 1, date[0]),
            "category_id": 0,
            "forHomePage": false
        }));
        setShowModal(true);
    };

    const onClickCancel = () => {
        setExpandedItemId(null);
        setSelectedNews(null);
        setShowModal(false);
    }

    const handleDelete = (id, ind) => {

        Swal.fire({
            title: "Изтриване на запис!",
            text: "Сигурни ли сте?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Да , изтриване"
        }).then((result) => {
            if (result.isConfirmed) {
                newsService.del(id)
                    .then(result => {
                        const copiedNewsData = [...newsData];
                        copiedNewsData.splice(ind, 1);
                        setNewsData(copiedNewsData);
                        Swal.fire({ title: "Изтриване!", text: "Избрания запис беше изтрит.", icon: "success" });
                    })
                    .catch(err => { Swal.fire({ icon: "error", title: "Oops...", text: err.message, }); })
            }
        });
    };

    const onClickHeandlerSaveEdit = (val) => {

        //console.log('format data');
        if (selNews.title === '') { Swal.fire({ title: "Внимание", text: 'Моля въведете заглавие на новината!', icon: "error" }); return; }
        if (!selNews.data) { Swal.fire({ title: "Внимание", text: 'Моля въведете дата за новината!', icon: "error" }); return; }
        if (selNews.news === '') { Swal.fire({ title: "Внимание", text: 'Моля въведете съдържание на новината!', icon: "error" }); return; }

        const body = {
            "title": selNews.title,
            "news": selNews.news,
            "data": FormatDateBG(selNews.data),
            "category_id": 0,
            "forHomePage": false
        }



        if (expandedItemId !== 0) {
            updateNews(body);
        }
        else {
            addNews(body);

        }




    }

    const updateNews = async (body) => {
        try {
            newsService.update(selNews.id_news, body)
                .then((res) => {
                    Swal.fire({ title: "Успешно обновяване!", text: "", icon: "success" });
                    populateNews();
                    setExpandedItemId(null);
                    setSelectedNews(null);
                    setShowModal(false);
                })
        } catch (error) {
            Swal.fire({ title: "Грешка при обновяване!", text: error.message, icon: "error" });
        }
    }

    const addNews = async (body) => {
        try {
            newsService.create(body)
                .then((res) => {
                    Swal.fire({ title: "Успешно добавена новина!", text: "", icon: "success" });
                    populateNews();
                    setExpandedItemId(null);
                    setSelectedNews(null);
                    setShowModal(false);

                })
        } catch (error) {
            Swal.fire({ title: "Грешка при добавяне!", text: error.message, icon: "error" });
        }
    }

    const onClickHeandlerAdd = (val) => {

        setSelectedNews({ "title": "", "news": "", "data": "", "category_id": 0, "forHomePage": false });
        setExpandedItemId(0);
        setShowModal(true);

    }


    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Преглед / Редакция на всички новини</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Новини</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">

                        <div className="row">



                            {(!newsData || expandedItemId != null) ? (<p>...</p>) : (
                                <>
                                    <table className="table table-striped table-hover w-100">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Дата</th>
                                                <th scope="col">Заглавие</th>
                                                <th className="text-center" scope="col">Действие</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {newsData.map((nd, index) => (
                                                <tr key={nd.id_news}>
                                                    <td>{index + 1}</td>
                                                    <td><a className="link_news" onClick={() => handleExpand(index)}>{nd.data}</a></td>
                                                    <td><a className="link_news" onClick={() => handleExpand(index)}>{nd.title}</a></td>
                                                    <td className="text-center">
                                                        <i className="bi bi-x-square del_but" onClick={() => { handleDelete(nd.id_news, index) }}></i>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="text-center">
                                        <button type="button" className="btn btn-primary mt-3 mb-3 w-32" onClick={() => onClickHeandlerAdd()} >Добави новина</button>
                                    </div>
                                </>
                            )}


                            {showModal &&
                                <div className="">
                                    <form>
                                        <div className="w-100">
                                            Заглавие:<br />
                                            <input type="text" id="title" name="title" value={selNews.title} onChange={handleContentChange} className="w-100 " />
                                        </div>
                                        <div className="mb-3 mt-2">
                                            <Calendar
                                                showButtonBar
                                                locale='bg'
                                                className="prime-dropdown-heigth"
                                                name="data"
                                                value={selNews.data ? selNews.data : null}
                                                onChange={handleContentChange}
                                                showIcon
                                            />
                                        </div>


                                        <SunEditor
                                            lang="en"
                                            autoFocus={true}
                                            name="html-editor"
                                            setOptions={{
                                                height: '50vh',
                                                buttonList: [
                                                    ['undo', 'redo'],
                                                    ['font', 'fontSize', 'formatBlock'],
                                                    ['paragraphStyle', 'blockquote'],
                                                    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                                    ['fontColor', 'hiliteColor', 'textStyle'],
                                                    ['removeFormat'],
                                                    ['outdent', 'indent'],
                                                    ['align', 'horizontalRule', 'list', 'lineHeight'],
                                                    ['table', 'link', 'image', /** 'video', 'audio'  ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.
                                                    /** ['imageGallery'] */ // You must add the "imageGalleryUrl".
                                                    ['showBlocks', 'codeView'],
                                                    ['preview', 'print'],
                                                ]
                                            }}
                                            setContents={selNews.news} // Initialize with HTML content
                                            onChange={handleContentChangeEditor}
                                        />
                                    </form>
                                    <div className="text-center">
                                        <button type="button" className="btn btn-danger mt-3 mb-3" onClick={() => onClickCancel()} >Отказ</button>
                                        <span className="ml-5"> </span>
                                        <button type="button" className="btn btn-primary mt-3 mb-3" onClick={() => onClickHeandlerSaveEdit()} >{expandedItemId !== 0 ? "Редакция" : "Добави"}</button>
                                    </div>
                                </div>

                            }


                        </div>

                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminAllNewsList;